import type {
  Data, Variables, Cache, UpdatesConfig,
} from '@urql/exchange-graphcache';

import invalidateQuery from '../util/invalidateQuery';

const offerContentMutations: UpdatesConfig['Mutation'] = {
  offerContentCreate: (data: Data, __: Variables, cache: Cache) => {
    invalidateQuery('offerContents', cache);
  },
  offerContentDelete: (data: Data, __: Variables, cache: Cache) => {
    invalidateQuery('offerContents', cache);
  },
  offerContentUpdate: (data: Data, __: Variables, cache: Cache) => {
    invalidateQuery('offerContents', cache);
  },
};

export default offerContentMutations;
